var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        avatar: true,
        checked: _vm.checked,
        [_vm.typeNetwork]: true,
        toggleDisplayReseau: _vm.toggleDisplayReseau,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event, _vm.id)
        },
      },
    },
    [
      _c("img", {
        attrs: { src: _vm.urlPicture ? _vm.urlPicture : "img/avatar.jpg" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }